import uniqueId from 'lodash/uniqueId';

const map = new WeakMap();
let index = 0;

export const weakKey = (obj) => {
  let key = map.get(obj);
  if (!key) {
    key = 'weak-key-' + index++;
    map.set(obj, key);
  }
  return key;
};

export const generateUniqueId = (prefix) => {
  const composedPrefix = `${prefix}_`;
  return `${uniqueId(composedPrefix)}_${Date.now()}`;
};
